import { render, staticRenderFns } from "./favorites.vue?vue&type=template&id=70689550&"
import script from "./favorites.vue?vue&type=script&lang=js&"
export * from "./favorites.vue?vue&type=script&lang=js&"
import style0 from "./favorites.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70689550')) {
      api.createRecord('70689550', component.options)
    } else {
      api.reload('70689550', component.options)
    }
    module.hot.accept("./favorites.vue?vue&type=template&id=70689550&", function () {
      api.rerender('70689550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/account/favorites.vue"
export default component.exports